import type { Activity } from '../schemas';

export type RestDay = {
  date: string;
  location: string;
};

export type CalendarDay = {
  date: string;
  title: string;
  activity: Activity | null;
  restDay: RestDay | null;
};

export const restDayLocations: Readonly<Record<string, string>> = {
  '2023-03-11': 'Hanmer Springs',
  '2023-03-17': "Arthur's Pass",
  '2023-03-20': 'Methven',
  '2023-03-21': 'Methven',
  '2023-03-28': 'Lake Tekapo',
  '2023-04-05': 'Wānaka',
  '2023-04-10': 'Queenstown',
  '2023-04-22': 'Invercargill',
};

export const numberFormat = new Intl.NumberFormat('en-NZ');
export const wholeNumberFormat = new Intl.NumberFormat('en-NZ', { maximumFractionDigits: 0 });
export const decimalFormat = new Intl.NumberFormat('en-NZ', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
export const dateFormat = new Intl.DateTimeFormat('en-NZ', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'Pacific/Auckland',
});

export function hasPhotoLocation<T extends { lat: number | null; lon: number | null }>(
  photo: T,
): photo is T & { lat: number; lon: number } {
  return photo.lat !== null && photo.lon !== null;
}

export function inclusiveDayCount(started: string, finished: string): number {
  const millisecondsPerDay = 86_400_000;
  const start = Date.parse(`${started}T00:00:00Z`);
  const finish = Date.parse(`${finished}T00:00:00Z`);
  return Math.floor((finish - start) / millisecondsPerDay) + 1;
}

function calendarDates(started: string, finished: string): string[] {
  const dates: string[] = [];
  const millisecondsPerDay = 86_400_000;
  const start = Date.parse(`${started}T00:00:00Z`);
  const end = Date.parse(`${finished}T00:00:00Z`);
  for (let timestamp = start; timestamp <= end; timestamp += millisecondsPerDay) {
    dates.push(new Date(timestamp).toISOString().slice(0, 10));
  }
  return dates;
}

export function buildCalendarDays(
  started: string,
  finished: string,
  activitiesByDate: ReadonlyMap<string, Activity>,
): CalendarDay[] {
  return calendarDates(started, finished).map((date) => {
    const activity = activitiesByDate.get(date) ?? null;
    const location = restDayLocations[date];
    const restDay = !activity && location ? { date, location } : null;
    return {
      date,
      activity,
      restDay,
      title: activity?.title ?? location ?? 'Rest day',
    };
  });
}
